import { render, staticRenderFns } from "./EventColorPicker.vue?vue&type=template&id=1d2417e3&"
import script from "./EventColorPicker.vue?vue&type=script&lang=js&"
export * from "./EventColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./EventColorPicker.vue?vue&type=style&index=0&id=1d2417e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports